<template>
    <div class="font-sans">
        <slot />
    </div>
</template>
